import clsx from 'clsx'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './auth.page.module.scss'
import { STEPPER_CONFIG } from './config/stepper-config'
import logoBlack from '../../assets/images/logo-black.png'
import logo from '../../assets/images/logo.png'
import { ProgressBar } from '../../common/ui/progress-bar/progress-bar'
import { RouteEnum } from '../../constants/routes.enum'
import { useRegisterStore } from '../../entities/auth/stores/register.store'

interface AuthHeaderProps {
  hasProgress?: boolean
}

export const AuthHeader: FC<AuthHeaderProps> = ({ hasProgress }) => {
  const navigate = useNavigate()
  const { step } = useRegisterStore()
  const maxStep = STEPPER_CONFIG.size

  const percent = Math.ceil((step * 100) / maxStep)

  const handleLogoClick = () => {
    navigate(RouteEnum.MAIN)
  }

  return (
    <div
      className={clsx(
        {
          [styles.headerWithProgressBar]: hasProgress,
        },
        styles.authHeader,
        'progress__container container-fluid d-flex gap-4 justify-content-between align-items-center text-white p-3',
      )}
    >
      <div className="logo cursor-pointer">
        <img
          alt="Sios-logo"
          onClick={handleLogoClick}
          src={hasProgress ? logo : logoBlack}
        />
      </div>

      {!!hasProgress && (
        <>
          <ProgressBar percent={percent} />
          <div className="progress-step text-nowrap p-2 rounded-3">
            {step} Шаг из {maxStep}
          </div>
        </>
      )}
    </div>
  )
}
